"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RenderEmailMessage = _interopRequireDefault(require("./RenderEmailMessage"));
var _RenderSmsMessage = _interopRequireDefault(require("./RenderSmsMessage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Render an entry from the nexus_message_log table. The props for this
 * component align directly with fields of the same names returned from
 * graphql.
 *
 * For best results, query for sentAt as follows:
 *     sentAt(format: "%a, %b %e, %Y @ %l:%i %p")
 */
var RenderLoggedMessage = function RenderLoggedMessage(props) {
  if (props.messageType === 'sms') {
    return /*#__PURE__*/_react["default"].createElement(_RenderSmsMessage["default"], props);
  }
  return /*#__PURE__*/_react["default"].createElement(_RenderEmailMessage["default"], props);
};
RenderLoggedMessage.propTypes = {
  messageInfo: _propTypes["default"].object,
  messageType: _propTypes["default"].string,
  sentAt: _propTypes["default"].string,
  status: _propTypes["default"].string
};
var _default = exports["default"] = RenderLoggedMessage;